export const ImcCalc = ({ weight, height, gender }) => {
  const calculateIMC = (weight, height) => {
    if (height <= 0) return 0;
    return (weight / ((height / 100) ** 2));
  };

  const classifyIMC = (imc, gender) => {
    if (!imc || !gender) return "";

    // Normal ranges diferenciados
    const ranges = {
      masculino: [
        { limit: 20.7, label: "Abaixo do peso" },
        { limit: 26.4, label: "Peso normal" },
        { limit: 27.8, label: "Sobrepeso" },
        { limit: 31.1, label: "Obesidade leve" },
        { limit: 34.9, label: "Obesidade moderada" },
        { limit: Infinity, label: "Obesidade severa" },
      ],
      feminino: [
        { limit: 19.1, label: "Abaixo do peso" },
        { limit: 25.8, label: "Peso normal" },
        { limit: 27.3, label: "Sobrepeso" },
        { limit: 32.3, label: "Obesidade leve" },
        { limit: 34.9, label: "Obesidade moderada" },
        { limit: Infinity, label: "Obesidade severa" },
      ],
    };

    const genderKey = gender.toLowerCase();

    for (const range of ranges[genderKey]) {
      if (imc <= range.limit) return range.label;
    }
  };

  const imcValue = calculateIMC(weight, height);
  const classification = classifyIMC(imcValue, gender);

  return {
    imc: imcValue.toFixed(2),
    classification,
  };
};
